import { type FC } from "react";

import { Check } from "./svgs/Check";
import { ChevronRight } from "./svgs/ChevronRight";
import { Magnifier } from "./svgs/Magnifier";

type IconProps = {
  name: "check" | "chevron-right" | "search";
};
export const Icon: FC<IconProps> = ({ name }) => {
  switch (name) {
    case "check":
      return <Check />;
    case "chevron-right":
      return <ChevronRight />;
    case "search":
      return <Magnifier />;
    default:
      return <></>;
  }
};
